import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useIntl } from 'react-intl';
import { usePaymentMethods } from './PaymentMethodProvider';
import { CREDIT_CARD, POINTS, SAMSUNG_PAY } from './paymentMethodTypes';
import { paymentMessages } from './paymentMessages';
import { PaymentImage } from './PaymentImage';

const PaymentMethodOption = ({ paymentMethod, selectedMethod, clickHandler, children }) => (
    <div className="payment-menu__option" key={paymentMethod} role="option" aria-selected={paymentMethod === selectedMethod}>
        <button
            type="button"
            onClick={() => clickHandler()}
            className={classnames({ 'payment-menu__btn': true, selected: selectedMethod === paymentMethod })}
        >
            {children}
        </button>
    </div>
);

PaymentMethodOption.propTypes = {
    paymentMethod: PropTypes.string.isRequired,
    selectedMethod: PropTypes.string.isRequired,
    clickHandler: PropTypes.func.isRequired,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};

const SelectPaymentMenu = () => {
    const { formatMessage } = useIntl();
    const { setSelectedMethod, selectedMethod, hasPoints, hasCreditCard, hasSamsungPay } = usePaymentMethods();
    return (
        <div className="payment-menu" role="listbox" aria-label={formatMessage(paymentMessages.paymentSelectLabel)}>
            <h4 className="payment-menu__heading">{formatMessage(paymentMessages.paymentType)}</h4>
            {hasPoints && (
                <PaymentMethodOption
                    paymentMethod={POINTS}
                    selectedMethod={selectedMethod}
                    clickHandler={() => setSelectedMethod(POINTS)}
                >
                    {formatMessage(paymentMessages.paymentWithPoints)}
                </PaymentMethodOption>
            )}
            {hasSamsungPay && (
                <PaymentMethodOption
                    paymentMethod={SAMSUNG_PAY}
                    selectedMethod={selectedMethod}
                    clickHandler={() => setSelectedMethod(SAMSUNG_PAY)}
                >
                    <PaymentImage card={SAMSUNG_PAY} />
                    {formatMessage(paymentMessages.paymentWithSamsungPay)}
                </PaymentMethodOption>
            )}
            {hasCreditCard && (
                <PaymentMethodOption
                    paymentMethod={CREDIT_CARD}
                    selectedMethod={selectedMethod}
                    clickHandler={() => setSelectedMethod(CREDIT_CARD)}
                >
                    <PaymentImage card={CREDIT_CARD} width='32px' height='24px' />
                    {formatMessage(paymentMessages.paymentWithCreditCard)}
                </PaymentMethodOption>
            )}
        </div>
    );
};

export default SelectPaymentMenu;
